import React, { createContext, useState, useContext } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(localStorage.getItem('authToken') || null);
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('userData')) || null);
    const [isAuthenticated, setIsAuthenticated] = useState(!!token);

    const loginUser = (userData) => {
        setToken(userData.token);
        setUser(userData);
        setIsAuthenticated(true);
        localStorage.setItem('authToken', userData.token);
        localStorage.setItem('userData', JSON.stringify(userData));
    };

    const logoutUser = () => {
        setToken(null);
        setUser(null);
        setIsAuthenticated(false);
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
    };

    return (
        <AuthContext.Provider value={{ token, user, isAuthenticated, loginUser, logoutUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
